import SignInButton from "../../../presentational/common/SignInButton";
import Login from "../Login";

const ConnectedSignInButton = props => (
  <Login {...props} PresentationComponent={SignInButton} />
);

export default ConnectedSignInButton;
